import { useTranslation } from "react-i18next";
import { formatTime } from "../../utils/converters/time-helper";
import SvgIcon from "../SvgIcon";

const MetconDisplay = ({ exercise, compact = false }) => {
  const { t } = useTranslation("coaching-portal");

  if (!exercise || exercise.primary !== "metcon") {
    return null;
  }

  const { structure, duration, totalRounds, restBetweenRounds } = exercise;

  return (
    <div className={`metcon-display ${compact ? "compact" : ""}`}>
      {!!structure && (
        <div className="metcon-structure">
          <SvgIcon src="/img/new-icons/vuesax-linear-tick-square-checked-nogradient.svg" />
          {exercise.structure}
        </div>
      )}

      {(duration || totalRounds) && (
        <div className="metcon-duration">
          {!!duration && (
            <div>
              <SvgIcon src="/img/new-icons/vuesax-linear-clock.svg" />
              {formatTime(duration)} {t("metconDisplay.duration")}
            </div>
          )}

          {!!totalRounds && (
            <div>
              <SvgIcon src="/img/new-icons/vuesax-linear-refresh-2.svg" />
              {totalRounds} {t("metconDisplay.rounds")}
            </div>
          )}
        </div>
      )}

      {!!restBetweenRounds && (
        <div className="metcon-rest">
          <SvgIcon src="/img/new-icons/vuesax-linear-timer-pause.svg" />
          {formatTime(restBetweenRounds)}{" "}
          {!compact && t("metconDisplay.restBetweenRounds")}
        </div>
      )}
    </div>
  );
};

export default MetconDisplay;
